import { LayerDefinition } from './types';

export const mountainVisibilityDefinition: LayerDefinition = {
  id: 'mountain_visibility',
  name: 'Mountain Visibility',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '🌫️',
  description: `Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.

Using high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:
• Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.
• In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.
• Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.

This gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.`,
  scoreDescription: `• Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.
• Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.
• Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.
• Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.`,
  sourceModels: ['nbm'],
  outputModels: ['Mountain Visibility (.pmtiles)'],
  config: {
    defaultModel: 'nbm'
  }
};

export default mountainVisibilityDefinition;
